<template>
    <div>
        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                    Ajoutez ici vos collaborateurs afin qu'ils puissent utiliser Dahub.<br />
                    À l'issu de la configuration de votre compte, ils recevront un e-mail les invitant à se joindre à
                    l'équipe.<br />
                </v-alert>

                <v-alert type="info" text class="mb-5">
                    Les membres de votre équipe doivent avoir un compte Apidae et l'utiliser pour se connecter sur Dahub.
                </v-alert>
            </div>
            <div class="col">
                <v-card :class="singleMod === undefined ? 'p-0 elevation-0' : 'p-4'">
                    <div class="mb-5">
                        <v-dialog v-model="dialog" persistent max-width="600px">
                            <template v-slot:activator="{ on }">
                                <v-btn outlined class="custom-button-primary" v-on="on">
                                    <v-icon left>add</v-icon> Ajouter un membre
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span v-if="!edit" class="headline">Création d'un membre d'équipe</span>
                                    <span v-else class="headline">Mise à jour d'un membre d'équipe</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined label="Prénom*" hide-details
                                                v-model="currentUser.first_name">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field outlined label="Nom*" hide-details
                                                v-model="currentUser.last_name">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field outlined label="E-mail*" required :disabled="edit"
                                                hide-details v-model="currentUser.email">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field outlined label="Téléphone" hide-details
                                                v-model="currentUser.phone">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field outlined label="Fonction" hide-details
                                                v-model="currentUser.job">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-checkbox class="mt-0" hide-details :disabled="!user.isAdmin"
                                                label="Administrateur" v-model="currentUser.isAdmin">
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>

                                    <v-alert type="error" v-if="showEmailNull">
                                        Vous devez renseigner l'email.
                                    </v-alert>

                                    <v-alert type="error"
                                        v-if="!isValidEmail && currentUser.email !== null && currentUser.email !== ''">
                                        Le format de l'email n'est pas bon.
                                    </v-alert>

                                    <v-alert type="error" v-if="showFirstNameNull">
                                        Vous devez renseigner le prénom
                                    </v-alert>

                                    <v-alert type="error" v-if="showLastNameNull">
                                        Vous devez renseigner le nom.
                                    </v-alert>

                                    <v-alert type="error" v-if="emailExist">
                                        Un utilisateur est déjà associé à cet email.
                                    </v-alert>

                                    <div class="d-flex justify-content-end gap-10">
                                        <v-btn @click="closeDialog">Annuler</v-btn>
                                        <v-btn class="default-button" @click="edit ? updateUser() : addUser()">Enregistrer</v-btn>
                                    </div>

                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </div>

                    <div v-if="account.users.length">
                        <v-data-table :headers="headers" :items="account.users" :loading="$global.loading"
                            class="border" :footer-props="{
                                itemsPerPageAllText: 'Toutes',
                                itemsPerPageText: 'Tags par page',
                                itemsPerPageOptions: [10, 20, 50, 100]
                            }">
                            <template v-slot:item.name="{ item }">
                                <div class="d-flex justify-content-between">
                                    <div v-if="isAdmin">
                                        <a @click="prepareUpdate(item)">
                                            {{ item.first_name }}
                                            {{ item.last_name }}
                                        </a>
                                    </div>
                                    <div v-else>
                                        {{ item.first_name }}
                                        {{ item.last_name }}
                                    </div>
                                    <v-tooltip bottom v-if="item.role.name == 'ADMIN'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon class="blue-grey--text text--darken-2" small v-bind="attrs"
                                                v-on="on">
                                                mdi-crown
                                            </v-icon>
                                        </template>
                                        <span>Administrateur</span>
                                    </v-tooltip>
                                </div>
                            </template>
                            <template v-slot:item.actions="{ on, item }">
                                <v-btn v-if="item.role.name !== 'ADMIN'" small icon v-on="on"
                                    class="custom-button-error" @click="deleteUser(item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else class="text-center">
                        <small>Aucun utilisateur n'a été ajouté pour le moment</small>
                    </div>
                </v-card>
            </div>
        </div>

        <div class="text-right mb-3 mt-5" v-if="singleMod === undefined">
            <v-btn class="default-button mt-3" @click="goNextStep">Passer à l'étape suivante</v-btn>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import Confirm from "../../tools/Confirm"
import * as EmailValidator from "email-validator"
import { mapState } from "vuex"

export default {
    name: "Team",
    props: ['singleMod'],
    components: { Confirm },
    data() {
        return {
            currentUser: { first_name: null, last_name: null, email: null, job: null, phone: null },
            dialog: false,
            showEmailNull: false,
            showFirstNameNull: false,
            showLastNameNull: false,
            confirm: false,
            showConfirm: false,
            edit: false,
            emailExist: false,
            headers: [
                {
                    text: 'Identité',
                    value: 'name'
                },
                {
                    text: 'Email',
                    value: 'email'
                },
                {
                    text: 'Téléphone',
                    value: 'phone'
                },
                {
                    text: 'Fonction',
                    value: 'job'
                },
                {
                    text: '',
                    value: 'actions'
                },
            ],
        }
    },
    methods: {
        goNextStep() {
            this.$global.$emit('change-step', 3)
        },
        addUser() {
            if (this.isValidEmail) {
                if (this.currentUser.email === null || !this.currentUser.email.length) {
                    this.showEmailNull = true
                } else if (this.currentUser.first_name === null || !this.currentUser.first_name.length) {
                    this.showFirstNameNull = true
                } else if (this.currentUser.last_name === null || !this.currentUser.last_name.length) {
                    this.showLastNameNull = true
                } else {
                    this.showEmailNull = false
                    this.showFirstNameNull = false
                    this.showLastNameNull = false
                    this.$global.loading = true

                    let payload = {
                        user: this.currentUser
                    }

                    this.$http.post('auth/user/create', payload).then(res => {
                        let exist = res.body.data.exist

                        this.$global.loading = false

                        if (!exist) {
                            this.$store.dispatch('account/getCredentials')

                            this.closeDialog()
                        } else {
                            this.emailExist = true
                        }
                    })
                }
            }
        },
        updateUser() {
            if (this.isValidEmail) {
                if (this.currentUser.email === null || !this.currentUser.email.length) {
                    this.showEmailNull = true
                } else if (this.currentUser.first_name === null || !this.currentUser.first_name.length) {
                    this.showFirstNameNull = true
                } else if (this.currentUser.last_name === null || !this.currentUser.last_name.length) {
                    this.showLastNameNull = true
                } else {
                    this.showEmailNull = false
                    this.showFirstNameNull = false
                    this.showLastNameNull = false
                    this.$global.loading = true

                    let payload = {
                        user: this.currentUser
                    }

                    this.$http.post('auth/user/update', payload).then(res => {
                        this.$global.loading = false

                        let exist = res.body.data.exist

                        if (res.body.success && !exist) {
                            this.$store.dispatch('account/getCredentials')

                            this.closeDialog()
                        } else {
                            this.emailExist = true
                        }
                    })
                }
            }
        },
        deleteUser(user) {
            this.$refs.confirm.open('Suppression d\'un utilisateur',
                'Êtes-vous sûr de vouloir supprimer l\'utilisateur <b>' +
                user.email + '<b> ?',
                { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.$global.loading = true

                        this.$http.delete('auth/user/' + user.id).then(res => {
                            this.$global.loading = false

                            if (res.body.success) {
                                this.$store.dispatch('account/getCredentials')
                            }
                        })
                    }
                })
        },
        closeDialog() {
            this.dialog = false
            this.edit = false
            this.currentUser = { first_name: null, last_name: null, email: null, job: null, phone: null }
            this.emailExist = false
        },
        prepareUpdate(user) {
            this.currentUser = JSON.parse(JSON.stringify(user))

            this.currentUser.isAdmin = this.currentUser.role.name === 'ADMIN'

            this.dialog = true
            this.edit = true
        }
    },
    computed: {
        ...mapState('account', ['account', 'user']),
        isValidEmail() {
            return EmailValidator.validate(this.currentUser.email)
        },
        isAdmin() {
            return ['SUPER_ADMIN', 'ADMIN', 'GOD'].includes(this.user.role.name)
        },
    }
}
</script>